import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {blue, grey} from '@mui/material/colors'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import {styled} from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, {tableCellClasses} from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import EmptyStateCard from 'app/components/emptyStates/emptyFolder'
import ShowMoreText from 'app/components/ShowMoreText'
import {useGetStripePrices} from 'app/hooks/subscription/useGetStripePrices'
import * as React from 'react'
import {useEffect, useState} from 'react'
import toastr from 'toastr'
import {emFormatToCurrency} from 'utilities/extensionMethods'
import PaymentCheckoutPlan from './PaymentCheckoutPlan'
import QuantityButton from './QuantityButton'
import {ProductResult} from './SubscriptionPlans'
export default function ShoppingCartSubscriptions({
  user_subscriptions,
}: {
  user_subscriptions?: any[]
}) {
  const [cartItems, setCartItems] = React.useState<any[]>()
  const queryGetProducts = useGetStripePrices()
  const [productList, setProductList] = useState<ProductResult[]>([])
  const [showCart, setShowCart] = React.useState<boolean>(false)
  const [qtyArr, setQtyArr] = React.useState<{product_id: string; seat_quantity: number}[]>([])

  const handleChangeQty = (product_id: string, seat_quantity: number) => {
    const qtyNew = qtyArr.filter((f) => f.product_id != product_id)
    setQtyArr([...qtyNew, {product_id: product_id, seat_quantity: seat_quantity}])
  }

  const handleChangeQtyInCart = (product_id: string, qty: number) => {
    setQtyArr((prev) => [
      ...prev.filter((f) => f.product_id != product_id),
      {product_id: product_id, seat_quantity: qty},
    ])
    cartItems?.map((m) => {
      if (m.product_id === product_id) {
        m.seat_quantity = qty
      }
    })
  }

  const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: grey[400],
      color: theme.palette.common.black,
      fontWeight: 700,
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))

  const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))

  function createData(
    id: string,
    name: string,
    min_price: number,
    min_seats: number,
    per_seat_price: number,
    seats: React.ReactElement,
    cart: React.ReactElement
  ) {
    return {id, name, min_price, min_seats, per_seat_price, cart, seats}
  }

  const handleAddToCart = (product_id: string, extra_seats: number) => {
    if (product_id) {
      const foundItem = cartItems?.find((f) => f.product_id === product_id)
      if (foundItem) {
        const newArr = [...(cartItems ?? []).filter((f) => f.product_id != product_id), foundItem]
        setCartItems(newArr)
      } else {
        const newArr = [...(cartItems ?? []), {product_id: product_id, seat_quantity: extra_seats}]
        setCartItems(newArr)
      }
      toastr.success(`Added plan to your cart`)
    }
  }

  const handlRemoveFromCart = (sid: string) => {
    const findit = cartItems?.find((f) => f.sid === sid)
    const newArr = cartItems ? [...cartItems.filter((f) => f.sid != sid)] : []
    setCartItems(newArr)
    findit &&
      toastr.warning(
        `Removed ${findit.quantity} ${findit.quantity > 1 ? 'items' : 'item'} from your cart`
      )
  }

  const rows = React.useMemo(() => {
    const r: any[] = []
    if (productList && Array.isArray(productList)) {
      productList?.map((p) => {
        if (p.prices.length > 0) {
          p.prices?.map((pr) => {
            r.push(
              createData(
                p.id,
                p.name,
                pr.min_price,
                pr.min_seats,
                pr.per_seat_price,
                <QuantityButton
                  value={qtyArr.find((f) => f.product_id === p.product_id)?.seat_quantity ?? 0}
                  product_id={p.product_id}
                  onChange={handleChangeQty}
                />,
                <Button
                  color={'success'}
                  onClick={() =>
                    handleAddToCart(
                      p.product_id,
                      qtyArr.find((f) => f.product_id === p.product_id)?.seat_quantity ?? 0
                    )
                  }
                  variant={'contained'}
                  size='small'
                  sx={{
                    position: 'inherit',
                    color: 'black',
                    textTransform: 'none',
                    fontWeight: 400,
                    width: '150px',
                    background: '#ffd814',
                    borderColor: '#fcd200',
                    borderRadius: '100px',
                    '&:hover': {
                      bgcolor: '#ffd814',
                      borderColor: '#fcd200',
                    },
                  }}
                >
                  {'Add To Cart'}
                </Button>
              )
            )
          })
        }
      })
    }
    return r
  }, [productList])

  useEffect(() => {
    if (queryGetProducts?.data) {
      console.log(`Loading ProductList.`)
      setProductList(queryGetProducts?.data.map((item: ProductResult) => item))
    }
  }, [queryGetProducts?.data])

  const options = {month: 'short', day: 'numeric'}

  return (
    <Grid container maxWidth={'1320px'} display={'flex'} margin={'auto'}>
      {!showCart ? (
        <Grid item xs={12}>
          <Table
            aria-label='customized table'
            sx={{
              '& .MuiTableRow-root': {
                position: 'inherit',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <StyledTableCell width={'12%'}>{'Subscription Plans'}</StyledTableCell>
                <StyledTableCell align='right' width={'12%'}>
                  Included Seats
                </StyledTableCell>
                <StyledTableCell align='right' width={'6%'}>
                  Price
                </StyledTableCell>

                <StyledTableCell align='right' width={'14%'}>
                  Price Per Additonal Seat
                </StyledTableCell>
                <StyledTableCell align='right' width={'12%'}>
                  Additional Seats
                </StyledTableCell>
                <StyledTableCell align='right' width={'12%'}>
                  <Button
                    sx={{
                      color: blue[900],
                      fontWeight: 700,
                      bgcolor: '#FFFFFF',
                      '&:hover': {bgcolor: grey[50]},
                      position: 'inherit',
                    }}
                    disabled={cartItems?.length === 0}
                    onClick={() => setShowCart(true)}
                    size={'small'}
                    variant={'contained'}
                    startIcon={<ShoppingCartIcon />}
                  >
                    {/* get the number of qty from the array of objects */}
                    View Cart: {cartItems?.reduce((acc, item) => acc + item.quantity, 0)}
                  </Button>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* put in a tab for basic one for add */}
              {rows.map((row, i) => {
                const today = new Date()
                const modifyDate = new Date(today)

                return (
                  <StyledTableRow key={row.name} sx={{position: 'relative'}}>
                    <StyledTableCell component='th' scope='row'>
                      <Typography variant={'body1'} fontWeight={700}>
                        {row.name ?? ''}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align='right'>{row.min_seats}</StyledTableCell>
                    <StyledTableCell align='right'>{row.min_price}</StyledTableCell>

                    <StyledTableCell align='right'>{row.per_seat_price}</StyledTableCell>
                    <StyledTableCell align='right'>{row.seats}</StyledTableCell>
                    <StyledTableCell align='right'>{row.cart}</StyledTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </Grid>
      ) : (
        <Grid item xs={12} flex={1} display={'flex'}>
          {cartItems?.length != 0 ? (
            <Box
              boxShadow={
                'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;'
              }
              width={'100%'}
            >
              <Box
                bgcolor={'white'}
                alignContent={'center'}
                display={'flex'}
                justifyContent={'space-between'}
                borderBottom={1}
              >
                <Typography variant={'h5'} fontWeight={700} p={2}>
                  Shopping Cart
                </Typography>
                <Button
                  onClick={() => setShowCart(false)}
                  variant={'text'}
                  sx={{
                    mr: 2,
                    color: blue[900],
                    fontWeight: 700,

                    '&:hover': {color: blue[900]},
                  }}
                >
                  Continue Shopping Plans
                </Button>
              </Box>

              {cartItems?.map((row) => (
                <Box m={1} p={2}>
                  <Grid container sx={{mb: 2}}>
                    <Box display={'flex'} p={0.5} bgcolor={'white'} width={'100%'}>
                      <Grid item xs={1}>
                        <div
                          style={{
                            display: 'flex',
                            maxWidth: '65px',
                            minWidth: '62px',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={'#'}
                            alt='logo'
                            style={{
                              display: 'flex',
                              width: '100%',
                              height: 'auto',
                            }}
                          />
                        </div>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography fontWeight={700}>{row.name?.replace('_', ' ')}</Typography>
                        <ShowMoreText
                          text={row.desc ?? ''}
                          maxLen={300}
                          moreString='...'
                          lessString='^'
                        />
                        <br />
                        Seats: {row.seat_quantity}
                        <QuantityButton
                          product_id={row.product_id}
                          value={row.seat_quantity}
                          onChange={handleChangeQtyInCart}
                        />
                        <Button
                          endIcon={<DeleteForeverIcon />}
                          onClick={() => handlRemoveFromCart(row.sid)}
                        >
                          Remove
                        </Button>
                      </Grid>
                      <Grid item xs={2}>
                        &nbsp;
                      </Grid>
                      <Grid item xs={1}>
                        <Typography fontWeight={700}>Item Price:</Typography>
                        {emFormatToCurrency((row.price ? row.price : 0) / 100)}
                      </Grid>
                    </Box>
                  </Grid>
                  <Divider />
                </Box>
              ))}

              {cartItems && (
                <Box display={'flex'} justifyContent={'flex-end'} p={2} alignItems={'center'}>
                  <Typography variant={'h6'}>
                    Subtotal: ({cartItems?.reduce((acc, item) => acc + item.quantity, 0)}{' '}
                    {cartItems?.reduce((acc, item) => acc + item.quantity, 0) > 1
                      ? 'items'
                      : 'item'}
                    )
                  </Typography>
                  <Typography variant={'h6'} fontWeight={700} p={2}>
                    {emFormatToCurrency(
                      cartItems
                        ?.map((x) => {
                          return x
                        })
                        .reduce((acc, x) => acc + ((x.price ? x.price : 0) * x.quantity) / 100, 0)
                    )}
                  </Typography>
                </Box>
              )}
              <Box display={'flex'} justifyContent={'flex-end'} p={2} bgcolor={grey[400]}>
                {cartItems && <PaymentCheckoutPlan items={cartItems} />}
              </Box>
            </Box>
          ) : (
            <Box display={'flex'} flexDirection={'column'} width={'100%'}>
              <Box
                bgcolor={'white'}
                display={'flex'}
                justifyContent={'space-between'}
                borderBottom={1}
                width={'100%'}
              >
                <Typography variant={'h5'} fontWeight={700} p={2}>
                  Shopping Cart
                </Typography>
                <Button
                  onClick={() => setShowCart(false)}
                  variant={'text'}
                  sx={{
                    mr: 2,
                    color: blue[900],
                    fontWeight: 700,
                    '&:hover': {color: blue[800]},
                  }}
                >
                  Continue Shopping Plans
                </Button>
              </Box>
              <Box>
                <EmptyStateCard
                  elevation={0}
                  subTitle={'No items added to your cart'}
                  p={3}
                  m={3}
                  img={'wind'}
                  size={'5em'}
                />
              </Box>
            </Box>
          )}
        </Grid>
      )}
    </Grid>
  )
}
